import type { GbTier } from "@/lib/pricing-utils";

// Fallback used when the live products API is unavailable — mirrors the
// per-GB mobile plans so pricing stays in sync when the feed is down.
export const FALLBACK_MOBILE_GB_TIERS: GbTier[] = [
  { gb: 25, monthlyPPG: 2, totalPrice: 50 },
  { gb: 50, monthlyPPG: 2, totalPrice: 100 },
  { gb: 100, monthlyPPG: 2, totalPrice: 200 },
  { gb: 200, monthlyPPG: 2, totalPrice: 400 },
  { gb: 500, monthlyPPG: 2, totalPrice: 1000 },
  { gb: 1000, monthlyPPG: 2, totalPrice: 2000 },
  { gb: 2000, monthlyPPG: 2, totalPrice: 4000 },
  { gb: 5000, monthlyPPG: 2, totalPrice: 10000 },
  { gb: 10000, monthlyPPG: 2, totalPrice: 20000 },
];

// Plan names for the first four tiers, by position.
export const CARD_PLAN_NAMES = ["Lite", "Standard", "Plus", "Scale"];

// Top highlights — the same set is shown on every card.
export const CARD_HIGHLIGHTS = [
  "Premium pooled mobile IPs",
  "Ethically sourced network",
  "City-level targeting",
  "HTTP & SOCKS5",
  "Real-time dashboard & API",
];

// Shared across every tier — shown once below the cards, not repeated per card.
export const PLAN_FEATURES = [
  "Premium pooled mobile IPs",
  "Unlimited access points",
  "City & ASN targeting",
  "HTTP & SOCKS5 support",
  "Random or sticky IP modes",
  "Username/password or IP whitelist auth",
  "Proxy list generator & cURL examples",
  "Real-time dashboard & API access",
];
